import {useModalContext} from '#/contexts/modal-provider';
import {useWalletProvider} from '#/contexts/wallet-provider';
import {useAddFundsAction} from '#/hooks/use-add-funds-action';
import {ClassName} from '#/utils/utils';
import {PlusIcon} from '@heroicons/react/24/solid';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

export const AddFundsButton: FunctionComponent<ClassName> = ({className = ''}) => {
  // Context
  const addFundsAction = useAddFundsAction();
  const {accountResult} = useWalletProvider();
  const {t} = useTranslation('translation');
  const {open} = useModalContext();

  const onClick = () => {
    addFundsAction();
  };

  if (!accountResult?.address) {
    return (
      <button
        className={`flex items-center gap-2 px-3 py-2 rounded-xl bg-deepblue shadow-2xl hover:scale-105 transition-all ease-in-out cursor-pointer whitespace-nowrap ${className}`}
        onClick={() => open({name: 'LoginModal', props: {}})}
      >
        <span className='text-sm text-white font-semibold'>{t('actions.login')}</span>
      </button>
    );
  }

  return (
    <button
      className={`flex items-center gap-2 px-3 py-2 rounded-xl bg-deepblue shadow-2xl hover:scale-105 transition-all ease-in-out cursor-pointer whitespace-nowrap ${className}`}
      onClick={onClick}
    >
      <PlusIcon className='w-4 h-4 fill-white stroke-transparent' />
      <span className='text-sm text-white font-semibold'>{t('actions.addFunds')}</span>
    </button>
  );
};
